module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABFUlEQVR4AWOgD8j2F0zxWBERsiDMb7afKWeqD1NOAGO2P0OGD0OmL0OWHxwhNAineG30M1sZHrouPIgjxUO8MkG+JlmlPp0jLxhFD8KGVO/5tgbbnfSmORjxZvorN2awZflHz+9VqE1lSPfGpiHFe4azySYfnYkuZhyp3kAn2fZWxC7sZ8v2x26DSLrXLEO9KVqmU0z0eTJ9gCLcBWH4/CCU6t1jqD/RxLLVxIA7HajBD1Uppg1pXrMsDTv0TabYGPFkgGwASuPVkOJd4GQa6WWe42rFl0qEBsEU910BPqfCvTc663OmeRPWIJDkcSTX9kJb+vZsb44kD0Iacvz5kn3WOarvs9Fd6qbLnuoL9DR2DYMSAACGloChRDHbigAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TM.png
// module id = 1282
// module chunks = 0